import angular from 'angular';

import component from './cvt-issues-header.component';

const CvtIssuesHeader = angular
    .module('control-room.internal.components.cvt.components.cvt-dashboard.components.cvt-issues-header', [])
    .component('crCvtIssuesHeader', component);

export default CvtIssuesHeader;
